import React from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import styles from '../styles.module.css'
import { useSelector } from 'react-redux';
import moment from 'moment';


const FIELDS = [
  {name: 'category', title: 'Категория (осн):'},
  {name: 'cert_date', title: 'Дата последней аттестации (осн):'},
  {name: 'category_sovmest', title: 'Категория (совмест):'},
  {name: 'cert_date_sovmest', title: 'Дата последней аттестации (совмест):'},
]

export default function TeacherInfo() {
  
  const auth = useSelector(state => state.auth)
  
  // const plan_cert_date = cert_date_sovmest
  //   ? moment(cert_date_sovmest, 'DD.MM.YYYY').add(5, 'y').format('DD.MM.YYYY')
  //   : moment().year()

  const renderPhoto = () => {
    if (auth.photo) return <img src={auth.photo} alt="о_О"/>
    else return <div>Фотография не загружена</div>
  }

  const renderItem = ({name, title}) => {
    if (auth[name]) return (
      <ListGroup.Item className={styles.teacherInfoItem}>
        <div>{title}</div>
        <div>{auth[name]}</div>
      </ListGroup.Item>
    )
  }

  return (
    <ListGroup className={`${styles.teacherInfoBlock} mb-4`}>
      <ListGroup.Item variant="primary" className={styles.teacherInfoTitle}>Личные данные</ListGroup.Item>
      <ListGroup.Item  className={styles.teacherPhoto}>{renderPhoto()}</ListGroup.Item>
      <ListGroup.Item className={styles.teacherInfoItem}>
        <div>ФИО:</div>
        <div>{auth.displayname}</div>
      </ListGroup.Item>
      {FIELDS.map(renderItem)}
    </ListGroup>
  )
}
